import { render, staticRenderFns } from "./view-columns.vue?vue&type=template&id=f40bd6c6&"
import script from "./view-columns.vue?vue&type=script&lang=js&"
export * from "./view-columns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports